angular.module('cvsApp').service('doPaymentService', ['networkService', 'xdrService', 'configManager', 'modifyFormOfPaymentModel', 'commonService','$rootScope',
	function(NS, XS, CM, MFPM, commonService,$rootScope) {

		function doPaymentService() {
			this.doPayment = function(formData, callBackSuccess, tokenId) {
				//get url
				var tid = tokenId || cvsUtility.queryMap.tokenId;
				var tokenType = (tokenId) ? 'Guest' : 'Login';
				var url = getsubmitPaymentUrl('SUBMIT_PAYMENT', tid, tokenType);
				if (url === "URL_ERROR") {

				} else {
					var request = {
						url: url,
						header: {
							"Content-Type": "application/xml"
						},
						data: getRequestBody(formData, tokenId),
						onSuccess: callBackSuccess
					}

					if (cvsUtility.getIEVersion() <= 9) {
						XS.makeRequest(url, getRequestBody(formData, tokenId), xdrSuccess);

						function xdrSuccess(data) {
							MFPM.setResponse(data);
							callBackSuccess(MFPM.getResponse());
						}
					} else {
						var promise = NS.post(request);
						promise.then(function(data, c, d) {

							MFPM.setResponse(data.data);
							callBackSuccess(MFPM.getResponse());

							//send message to parent
							//cvsUtility.sendPostMessage("SESSION-ALIVE", "modifyFormOfPayment");

						}, function(reason) {
							callBackSuccess(NS.httpError(reason));
						});
					}

				}

			}
			var payment = {};
			this.setPayment = function(data) {
				payment = data;
			}

			this.getPayment = function() {
				return payment;
			}

			function getsubmitPaymentUrl(serviceKey, tokenId, tokenType) {
				if (cvsUtility.queryMap.env == "" || cvsUtility.queryMap.env == undefined || cvsUtility.queryMap.apikey == "" || cvsUtility.queryMap.apikey == undefined) {
					if (tokenType == "QReg") {
						return "URL_ERROR";
					} else {
						if (tokenId == "" || tokenId == undefined)
							return "URL_ERROR";
					}
				} else {
					var url = CVS.Config.serviceHost[cvsUtility.queryMap.env] + "specialty/" + CVS.Config.services[serviceKey].URL + "?serviceName=" + CVS.Config.services[serviceKey].serviceName + "&";
				   
					var appConfigs = getsubmitPaymentappConfig(config);
					return url + appConfigs + "&version=3.0";
				}
			}

			function getsubmitPaymentappConfig(configVariable) {
				return _.map(configVariable, function (val, key) {
					return key + "=" + val;
				}).join("&");
			}

			var getRequestBody = function(formData, tokenId) {
				var date = new Date();
				var tid = tokenId || cvsUtility.queryMap.tokenId;
				var tokenType = (tokenId) ? 'Guest' : 'Login';

				var requestJson = {
					request: {
						tokenID: tid,
						tokenType: tokenType,
						apiKey: cvsUtility.queryMap.apikey,
						timestamp: cvsUtility.getTimeStamp(),
						componentID: formData.componentID,
						fastIndicator: formData.fastIndicator,
						paymentMethodDetails: {
							paymentMethodId: formData.transactionMode == 'ADD' ? null : formData.paymentMethodId,
							payment: {
								method: formData.payment.method,
								type: formData.payment.type && formData.payment.type == "ONETIME" ? "ONETIME" : ("" + formData.payment.type).toUpperCase(),
								frequency: formData.payment.type == "ONETIME"?"":(""+formData.payment.frequency).toUpperCase(),
								amount: formData.payment.amount,
								fsaIndicator: formData.payment.fsaIndicator
							},
							accountNumber: (formData.transactionMode == 'EDIT' || formData.transactionMode == 'NONE') ? null : formData.encryptedAccountNumber,
							routingNumber: (formData.transactionMode == 'EDIT' || formData.transactionMode == 'NONE') ? null : formData.routingNumber,
							cardholderName: {
								firstName: formData.cardholder.firstName,
								middleName: '',
								lastName: formData.cardholder.lastName
							},
							billingAddress: {
								addressLine1: formData.billingAddress.addressLine1,
								addressLine2: formData.billingAddress.addressLine2,
								city: formData.billingAddress.city,
								state: formData.billingAddress.state,
								zipCode: formData.billingAddress.zipCode,
								zipCodeExt: formData.billingAddress.zipCodeExt
							},
							expiryDate: {
								month: (formData.expiryDate == undefined) ? '' : formData.expiryDate.month,
								year: (formData.expiryDate == undefined) ? '' : formData.expiryDate.year
							},
							paymentCurrency: formData.paymentCurrency,
							paymentIndicator: formData.paymentIndicator,
							transactionMode: formData.transactionMode,
							activeFlag: formData.activeInd?formData.activeInd :'ACTIVE',
							relationshipToCardHolder: formData.relationshipToCardHolder,
							overrideIndicator: "true",
							expiredIndicator: formData.expiredIndicator,
							achAcceptanceInd: formData.achAcceptanceInd

						}
					}
				};
				
				if (formData.transactionMode == 'ADD') {
					requestJson.request.paymentMethodDetails.createdBy = formData.createdBy;
				} else {
					requestJson.request.paymentMethodDetails.updatedBy = formData.createdBy;
				}

				return cvsUtility.JSONToXml(requestJson);
			}
		}

		return new doPaymentService();
	}
]);
